/**
 * PATH: packages/ui/src/kanban/components/card-detail/entries/entriesFocusSignal.ts
 * FILE_ID: UI-KANBAN-ENTRIES-FOCUS-001
 * PURPOSE: One-shot "open the drawer focused on the Entries table"
 *          handshake between the card-face rail button and
 *          CardEntriesSection, without threading a prop through the
 *          drawer's public contract.
 * WHY: The rail button opens the drawer via the host's normal
 *      setDetailCard pipe; the section (mounted deep inside the
 *      drawer) consumes the pending card id on mount and scrolls
 *      itself into view. Module-level because both ends live in the
 *      same bundle; cleared on consume so re-opening the drawer by
 *      hand never re-scrolls.
 */

let pendingCardId: string | null = null

/** Arm the focus for the next drawer mount of `cardId`'s Entries table. */
export function requestEntriesFocus(cardId: string): void {
  pendingCardId = cardId
}

/** True (and disarms) when `cardId` has a pending Entries focus. */
export function consumeEntriesFocus(cardId: string): boolean {
  if (pendingCardId !== cardId) return false
  pendingCardId = null
  return true
}
